import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import {
  jerboaClientPreviewDetailResponseSchema,
  jerboaClientPreviewSourcePlatformSchema,
  jerboaClientPreviewStatusSchema,
  jerboaClientPreviewsListResponseSchema,
  playbackAnalysisResponseSchema,
} from "./schemas";

export const fetchJerboaClientPreviewsQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa-client-previews", "list"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-client-previews",
  paramsSchema: z.object({
    afterCursor: z.string().nullable().optional().default(null),
    pageSize: z.number().max(50).optional().default(20),
    status: jerboaClientPreviewStatusSchema.optional(),
    projectId: z.string().optional(),
    sourcePlatform: jerboaClientPreviewSourcePlatformSchema.optional(),
  }),
  responseSchema: jerboaClientPreviewsListResponseSchema,
}).withPagination({
  getNextPageParam(lastPage) {
    return lastPage.pageInfo.hasNextPage ? lastPage.pageInfo.endCursor : undefined;
  },
  mapPaginationParamsToQueryParams({ pageParam }) {
    return {
      ...(pageParam ? { afterCursor: pageParam } : {}),
      pageSize: 20,
    };
  },
});

export const getJerboaClientPreviewQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa-client-previews", "detail"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-client-previews/:id",
  responseSchema: jerboaClientPreviewDetailResponseSchema,
});

export const fetchJerboaClientPreviewAnalysisQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa-client-previews", "analysis"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-client-previews/analysis",
  paramsSchema: z.object({
    days: z.number().min(1).max(90).default(7),
  }),
  responseSchema: playbackAnalysisResponseSchema,
});
